import DashboardTopbar from "@/components/DashboardTopbar"
import { BarChart, BarList } from "@tremor/react"
import Card from "@/components/Card"
import { ReactNode } from "react"
import AdminNavigation from "@/components/admin/AdminNavigation"
import AppLayout from "@/layouts/AppLayout"
import { usePage } from "@inertiajs/react"
import { AdminPuzzlesProps } from "@/types/types"

const AdminPuzzlesPage = () => {
  const { public_puzzles, total_puzzles, pageviews, most_visited, histogram } =
    usePage<AdminPuzzlesProps>().props

  return (
    <>
      <DashboardTopbar title="Admin" />
      <AdminNavigation />

      <div className="padding grid w-full max-w-7xl gap-6 py-4 sm:py-6 lg:grid-cols-2 lg:py-8">
        <Card title="Total non-draft puzzles" value={total_puzzles} />
        <Card title="Public puzzles" value={public_puzzles} />

        <Card title="Total puzzle views (Last 30 days)" value={pageviews}>
          <BarChart
            data={histogram}
            index="date"
            categories={["Pageviews"]}
            colors={["blue"]}
            startEndOnly
            showLegend={false}
            yAxisWidth={40}
            className="h-full w-full"
          />
        </Card>

        <Card title="Most viewed puzzles (Last 30 days)" value={null}>
          <BarList data={most_visited} className="h-full w-full" />
        </Card>
      </div>
    </>
  )
}

AdminPuzzlesPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>

export default AdminPuzzlesPage
